import React, { FC } from 'react';

import ReactMarkdown from 'react-markdown';
import cn from 'classnames';
import rehypeRaw from 'rehype-raw';
import { identity } from 'ramda';

import styles from './Markdown.module.css';

const rehypePlugins = [rehypeRaw];

interface Props {
  className?: string;
  content?: string;
}

const Markdown: FC<Props> = ({ content, className }) => {
  if (!content) return null;

  return (
    <ReactMarkdown
      rehypePlugins={rehypePlugins}
      className={cn(styles.default_style, className)}
      transformLinkUri={identity}
    >
      {content}
    </ReactMarkdown>
  );
};

export default Markdown;
